import { render, staticRenderFns } from "./ongletsAdministration.vue?vue&type=template&id=5a31ef83&scoped=true"
import script from "./ongletsAdministration.vue?vue&type=script&lang=js"
export * from "./ongletsAdministration.vue?vue&type=script&lang=js"
import style0 from "./ongletsAdministration.vue?vue&type=style&index=0&id=5a31ef83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31ef83",
  null
  
)

export default component.exports